import * as React from "react";
import { observer } from "mobx-react-lite";
import { Box, Text6 } from "@telefonica/mistica";

interface IProps {
	title: string;
}

export const Heading: React.FC<IProps> = observer((props) => {
	const { title } = props;

	return (
		<Box padding={24} className="centered-on-desktop">
			<Text6>{title}</Text6>
		</Box>
	);
});
